import { render, staticRenderFns } from "./outros.vue?vue&type=template&id=ae2f5c28&scoped=true&"
import script from "./outros.vue?vue&type=script&lang=js&"
export * from "./outros.vue?vue&type=script&lang=js&"
import style0 from "./outros.vue?vue&type=style&index=0&id=ae2f5c28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae2f5c28",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VCol,VRow,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("D:\\Trabalho\\Lupa Soluções em TI\\Clientes\\Leonardo Raton\\Site\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ae2f5c28')) {
      api.createRecord('ae2f5c28', component.options)
    } else {
      api.reload('ae2f5c28', component.options)
    }
    module.hot.accept("./outros.vue?vue&type=template&id=ae2f5c28&scoped=true&", function () {
      api.rerender('ae2f5c28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/Modal/tiposAtivos/Outros/outros.vue"
export default component.exports